import React, { createContext, useEffect, useState, useContext } from 'react';
import { io } from 'socket.io-client';
import { SOCKET_URL } from '../utils/constants';
import { AuthContext } from './AuthContext';

export const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const { user, token } = useContext(AuthContext);
  const [socket, setSocket] = useState(null);
  const [onlineUsers, setOnlineUsers] = useState(new Set());

  useEffect(() => {
    if (user && user._id) {
      const socketInstance = io(SOCKET_URL, {
        auth: {
          token
        },
        withCredentials: true
      });

      socketInstance.on('connect', () => {
        console.log('[SocketConnected]:', socketInstance.id);
        socketInstance.emit('join_room', { userId: user._id });
      });

      socketInstance.on('user_status_changed', ({ userId, isOnline }) => {
        setOnlineUsers((prev) => {
          const updated = new Set(prev);
          if (isOnline) updated.add(userId);
          else updated.delete(userId);
          return updated;
        });
      });

      setSocket(socketInstance);

      return () => {
        socketInstance.disconnect();
      };
    } else if (socket) {
      socket.disconnect();
      setSocket(null);
    }
  }, [user]);

  return (
    <SocketContext.Provider value={{ socket, onlineUsers }}>
      {children}
    </SocketContext.Provider>
  );
};
